'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Tooltip = require('../../../Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TinyLink = function TinyLink(_ref) {
  var icon = _ref.icon,
      tooltip = _ref.tooltip,
      rest = _objectWithoutProperties(_ref, ['icon', 'tooltip']);

  return _react2.default.createElement(
    _Tooltip2.default,
    {
      content: _react2.default.createElement(
        'span',
        { style: { whiteSpace: 'nowrap' } },
        tooltip
      ),
      moveBy: { x: 3, y: 15 },
      appendToParent: true
    },
    _react2.default.createElement(
      'a',
      _extends({ className: _styles2.default.link + ' ' + _styles2.default.tinyLink }, rest),
      _react2.default.createElement(
        'div',
        { className: _styles2.default.linkIcon },
        icon
      )
    )
  );
};

TinyLink.propTypes = {
  icon: _propTypes2.default.node.isRequired,
  tooltip: _propTypes2.default.string.isRequired
};

exports.default = TinyLink;